import AptUnitPreviewCard from "@/routes/admin/apt/[apt_code]/unit-size/apt-unit-preview-card"
import { aptUnitSizeStore } from "@/routes/admin/apt/[apt_code]/unit-size/apt-unit-size-store"
import { useEffect } from "react"
import { useParams } from "react-router-dom"
import Flex from "@/components/flex"
import AptUnitEditorModal from "@/routes/admin/apt/[apt_code]/unit-size/modal/apt-unit-editor-modal"

const AdminAptUnitSizePage = () => {
  const { aptCode } = useParams()
  const { palette, aptUnitSizeMap, selectedDong, setSelectedDong } = aptUnitSizeStore()

  useEffect(() => {
    aptUnitSizeStore.getState().apiGetAptSize(aptCode)

    return () => {
      aptUnitSizeStore.getState().reset()
    }
  }, [aptCode])

  if (!palette) return null

  return (
    <section className="w-full">
      <div className="flex justify-end">
        <div className="flex flex-wrap max-w-160 justify-end gap-x-2 mt-2">
          {Object.keys(palette).length > 0 ? (
            Object.keys(palette).map((size) => (
              <Flex className="items-center" key={size} gap={6}>
                <div className="w-3 h-3" style={{ backgroundColor: palette[size] }} />
                <p className="min-w-20">{size}</p>
              </Flex>
            ))
          ) : (
            <p className="text-gray-400">등록된 아파트 평형 정보가 없습니다.</p>
          )}
        </div>
      </div>
      <div className="grid grid-cols-4 gap-4 mt-4">
        {aptUnitSizeMap &&
          Object.entries(aptUnitSizeMap).map(([dong, unitMap]) => (
            <AptUnitPreviewCard
              key={dong}
              dong={dong}
              palette={palette}
              unitMap={unitMap}
              onClick={() => setSelectedDong(dong)}
            />
          ))}

        <button
          onClick={() =>
            setSelectedDong(
              Object.keys(aptUnitSizeMap).length > 0
                ? Math.max(...Object.keys(aptUnitSizeMap).map(Number)) + 1
                : 1
            )
          }
          className="border-2 border-dashed rounded-xl h-full min-h-80 
          flex items-center justify-center 
          text-4xl text-gray-400 hover:bg-gray-50 cursor-pointer"
        >
          +
        </button>
      </div>

      {selectedDong && (
        <AptUnitEditorModal
          dong={selectedDong}
          palette={palette}
          unitMap={aptUnitSizeMap[selectedDong]}
        />
      )}
    </section>
  )
}

export default AdminAptUnitSizePage
